const REGION = 'US-NEW'
const IMAGEFOLDER = 'worldHearingDay'

const worldHearingDayTextAndMedia = {
  heroSection: {
    heading: `Celebrating World Hearing Day 2024`,
    title: `You are full of possibilities.`,
    videoName: 'possibilityVideo.mp4',
    videoPosterName: 'possibilityVideoPoster.jpg'
  },
  negativeVoice: {
    heading: `None of these negative voices, none is true.`,
    imageName: 'negativeVoice.png'
  },
  hearingLossIsCommon: {
    heading: `Hearing loss is more common than one may think.`,
    backgroundImageName: `hearingLossBanner.jpg`
  },
  hearingLossIsNormal: {
    heading: [
      `In fact, `,
      `hearing loss can occur in anyone regardless of race, gender, or age`
    ],
    subtitle: [
      `WHO estimated over `,
      `1.5 billion people worldwide `,
      `have hearing loss. `,
      `38% of adults `,
      `aged 20 to 79 years have audiometrically measured
    hearing loss.`
    ],
    hearingLossGroupImageName: `hearingLossGroup.png`
  },
  hearingTreatment: {
    heading: [
      `And getting `,
      `hearing treatment `,
      `is like getting `,
      `eyeglasses.`
    ],
    subtitle: `Imagine squinting to see something; that’s a sign your eyes might need a little help to see better. If you find it hard to hear, your ears might need assistance too.`,
    hearingTreatmentImageName: `hearingLossTreatmentFlow.png`
  },
  hearingLossNotDefineYourself: {
    heading: `Hearing loss doesn't define who you are.`,
    subtitle: `Believe in your ability to achieve anything. Embrace your dreams and rise above challenges.`,
    hearingLossNotDefineYourselfVideoName: `hearingLoss.mp4`,
    hearingLossNotDefineYourselfVideoPosterName: `hearingLossPoster.jpg`
  },
  orkaMissionBanner: {
    heading: `Born out of a passion for advocating hearing loss`,
    orkaMissionBannerImageName: `orkaMissionBanner.jpg`
  },
  xinkeStory: {
    heading: `Orka’s Co-Founder, Xinke Liu: `,
    title: `Taking charge of your hearing loss`,
    subtitle: `"Honestly, not wearing my cochlear implants for surfing? Does it really impact my performance? Not at all! Hearing devices are just tools. You shouldn't let them take over your life or who you are."`,
    buttonText: `Read Full Story`,
    xinkeImagePath: `xinkeImg.jpg`
  },
  orkaMissionAndVision: {
    missionHeading: `Our Mission`,
    missionSubtitle: `To create a world with fewer limits and maximize human potential.`,
    missionContent: `Our immediate aim is to improve the lives of those with hearing loss by offering innovative and high-quality hearing solutions that empower customers to communicate freely and engage fully in life's significant moments.`,
    missionImageName: `missionImg.jpg`,
    visionHeading: `Our Vision`,
    visionSubtitle: `To empower people to embrace health and pursue limitless possibilities daily.`,
    visionContent: `We aspire to make healthcare not a luxury limited by price or technology, but an easily accessible part of everyday life. We envision a world where health is not a burden but a joyous journey, led and participated by everyone.`,
    visionImageName: `visionImg.jpg`
  },
  orkaTwoHearingAids: {
    heading: `We put our manifesto into action`,
    title: `Orka Two Hearing Aids`,
    orkaTwoVideoName: `orkaTwo.mp4`,
    orkaTwoVideoPosterName: `orkaTwoPoster.jpg`
  },
  learnMoreAboutOrkaTwo: {
    heading: `Ready to get started?`,
    leftHeading: `See if Orka Two is the right fit for you`,
    leftButtonCTA: `Take a 3-Min Quiz`,
    leftButtonLink: `/SurveyPage`,
    rightHeading: `Or let a Product Specialist help with you`,
    rightPhoneNumber: `(800) 653-6022`,
    rightPhoneNumberLink: `tel:(800) 653-6022`,
    rightWorkingHour: `Working Hours: 9 AM - 6 PM EST Mon-Fri`
  }
}

export { REGION, IMAGEFOLDER, worldHearingDayTextAndMedia }
